import { Button, Grid, Select, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { Animated } from 'react-animated-css';
import { connect } from 'react-redux';
import Url from 'url';
import join from 'url-join';
import { ApiServerUrl } from '../config.json';
import { Link, withRouter } from 'react-router-dom';
import { withLang } from '../util/lang';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import frontend_config from '../frontend_config';
import { getWebAbsPath } from '../util/path';
import { updateRes } from '../store/res/res.action';
import KnowledgeForm from '../components/Support/knowledgeForm';
import DistrGpSelector from '../components/Support/DistrGpSelector';
import axios from '../../src/axios-default';
import { el } from 'date-fns/locale';
import Banner from '../components/Banner';

const hostname = window.location.hostname;

// material ui and css stuff
// import { Grid } from '@material-ui/core'

const styles = (theme) => ({
    root: {
        margin: '48px auto',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
        },
    },
    supportContainer: {
        padding: 36,
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
            padding: 16,
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
            marginLeft: '15%',
        },
    },
    devicesContainer: {
        padding: 16,
        background: '#f2f2f2',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    },
});

class Support extends Component {
    constructor(props) {
        super(props);
        const localStorageDistrGroupId =
            JSON.parse(JSON.parse(localStorage.getItem('distr_group_id'))) ||
            JSON.parse(JSON.parse(localStorage.getItem('doctor_dist_id'))); //'"null"' is example of data from localStorage. JSON parse twice to get a null value.
        this.state = {
            selectedDistrForm: localStorageDistrGroupId ?? 'default',
            selectedDistKnowledge: localStorageDistrGroupId ?? 'default',
            allDistrGpId: -1,
            knowledgeArticleToShow: [],
            knowledgeVideoToShow: [],
            formToShow: [],
            rowPerPageArticle: 30,
            rowPerPageVideo: 30,
            articleShowingFirstIndex: 0,
            videoShowingFirstIndex: 0,
            isAdmin: JSON.parse(localStorage.getItem('role')).includes('ADMIN'),
        };

        this.handleSelectFormChange = this.handleSelectFormChange.bind(this);
        this.handleSelectKnowledgeChange = this.handleSelectKnowledgeChange.bind(this);
        this.handleVideoRowPerPageChange = this.handleVideoRowPerPageChange.bind(this);
        this.handleArticleRowPerPageChange = this.handleArticleRowPerPageChange.bind(this);
        this.handleSetPage = this.handleSetPage.bind(this);
    }

    componentDidUpdate(_, prevState) {
        const {
            knowledgeArticleToShow,
            knowledgeVideoToShow,
            formToShow,
            selectedDistrForm,
            selectedDistKnowledge,
            rowPerPageVideo,
            rowPerPageArticle,
        } = this.state;
        const { knowledge_base_article, knowledge_base_video, form_download } = this.props;
        if (prevState.selectedDistKnowledge !== selectedDistKnowledge) {
            this.setState({
                knowledgeArticleToShow: [
                    knowledgeArticleToShow[0],
                    sortHelper(knowledge_base_article[selectedDistKnowledge]),
                ],
                knowledgeVideoToShow: [
                    knowledgeVideoToShow[0],
                    sortHelper(knowledge_base_video[selectedDistKnowledge]),
                ],
            });
        }
        if (prevState.selectedDistrForm !== selectedDistrForm) {
            this.setState({
                formToShow: [formToShow[0], sortHelper(form_download[selectedDistrForm])],
            });
        }

        if (prevState.rowPerPageVideo !== rowPerPageVideo) {
            this.setState({
                videoShowingFirstIndex: 0,
            });
        }
        if (prevState.rowPerPageArticle !== rowPerPageArticle) {
            this.setState({
                articleShowingFirstIndex: 0,
            });
        }
    }

    async componentDidMount() {
        await this.props.updateFrom();
        await this.props.updateKnowledge();
        await this.props.updateDistrGroup();
        var allDistrGpId;
        if (this.state.isAdmin) {
            allDistrGpId = Object.keys(this.props.distr_groups).find((key) => {
                const { distr_group_name } = this.props.distr_groups[key] || { distr_group_name: null };
                return distr_group_name.toLowerCase() === 'all';
            });
        } else {
            const obj = {
                ...this.props.form_download,
                ...this.props.knowledge_base_article,
                ...this.props.knowledge_base_video,
            };
            allDistrGpId = Object.keys(obj).find((key) => {
                const { distr_group_name } = obj[key][0] || { distr_group_name: null };
                return distr_group_name.toLowerCase() === 'all';
            });
        }
        const { selectedDistKnowledge, selectedDistrForm } = this.state;
        const { knowledge_base_article, knowledge_base_video, form_download } = this.props;
        this.setState({
            allDistrGpId,
            knowledgeArticleToShow: [
                sortHelper(this.props.knowledge_base_article[allDistrGpId]),
                sortHelper(knowledge_base_article[selectedDistKnowledge]),
            ],
            knowledgeVideoToShow: [
                sortHelper(this.props.knowledge_base_video[allDistrGpId]),
                sortHelper(knowledge_base_video[selectedDistKnowledge]),
            ],
            formToShow: [
                sortHelper(this.props.form_download[allDistrGpId]),
                sortHelper(form_download[selectedDistrForm]),
            ],
        });
    }

    handleSelectFormChange = (e) => {
        this.setState({
            selectedDistrForm: e.target.value,
        });
    };

    handleSelectKnowledgeChange = (e) => {
        this.setState({
            selectedDistKnowledge: e.target.value,
        });
    };

    handleArticleRowPerPageChange = (e) => {
        this.setState({
            rowPerPageArticle: e.target.value,
        });
    };
    handleVideoRowPerPageChange = (e) => {
        this.setState({
            rowPerPageVideo: e.target.value,
        });
    };

    handleSetPage = (type, action) => {
        const {
            knowledgeVideoToShow,
            rowPerPageVideo,
            knowledgeArticleToShow,
            rowPerPageArticle,
            videoShowingFirstIndex,
            articleShowingFirstIndex,
        } = this.state;
        const rowPerPage = type.toLowerCase() === 'video' ? rowPerPageVideo : rowPerPageArticle;
        const firstIndex = type.toLowerCase() === 'video' ? videoShowingFirstIndex : articleShowingFirstIndex;
        const knowledgeToShow = type.toLowerCase() === 'video' ? knowledgeVideoToShow : knowledgeArticleToShow;
        const stateToChange = type.toLowerCase() === 'video' ? 'videoShowingFirstIndex' : 'articleShowingFirstIndex';
        const lastPageIndex =
            knowledgeToShow.flat().length - (knowledgeToShow.flat().length % rowPerPage || rowPerPage);
        switch (action) {
            case 'first_page':
                this.setState({
                    [stateToChange]: 0,
                });
                break;
            case 'last_page':
                this.setState({
                    [stateToChange]: lastPageIndex,
                });
                break;
            case 'previous_page':
                this.setState({
                    [stateToChange]: firstIndex - rowPerPage >= 0 ? firstIndex - rowPerPage : 0,
                });
                break;
            case 'next_page':
                this.setState({
                    [stateToChange]: firstIndex + rowPerPage <= lastPageIndex ? firstIndex + rowPerPage : lastPageIndex,
                });
                break;
            default:
                return;
        }
    };

    render() {
        const { classes } = this.props;
        const {
            selectedDistrForm,
            selectedDistKnowledge,
            allDistrGpId,
            knowledgeArticleToShow,
            knowledgeVideoToShow,
            formToShow,
            rowPerPageArticle,
            rowPerPageVideo,
            articleShowingFirstIndex,
            videoShowingFirstIndex,
        } = this.state;
        return (
            <Animated animationIn="fadeIn" isVisible={true}>
                <Grid container className={classes.devicesContainer}>
                    <Grid item xs={12}>
                        <Banner />
                    </Grid>
                </Grid>

                <Grid container className={classes.supportContainer} align="center">
                    <Grid
                        item
                        xs={12}
                        style={{
                            textAlign: 'left',
                            boxShadow: '-2px 6px 24px -9px rgba(166,130,166,1)',
                            width: '100%',
                            maxHeight: '400px',
                        }}
                    >
                        <Grid container>
                            <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
                                <img src={getWebAbsPath('/img/support1.png')} style={{ width: '100%' }} />
                            </Grid>
                            <Grid item xs={12} sm={6} style={{ padding: 24 }}>
                                <h3
                                    style={{
                                        textAlign: 'left',
                                        fontWeight: 600,
                                        color: '#2eafb6',
                                        fontSize: 36,
                                        marginBlockStart: 0,
                                        marginBlockEnd: 0,
                                    }}
                                >
                                    {this.get('contactInfo')}
                                </h3>
                                <hr
                                    style={{ border: 'solid 3px #2eafb6', width: 88, margin: '16px 0px' }}
                                    align="left"
                                />
                                <p style={{ margin: '24px 0px' }}>{localStorage.getItem('tel')}</p>
                                <p style={{ margin: '24px 0px' }}>{localStorage.getItem('email')}</p>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container className={classes.supportContainer} align="center">
                    <Grid
                        item
                        xs={12}
                        style={{
                            textAlign: 'left',
                            boxShadow: '-2px 6px 24px -9px rgba(166,130,166,1)',
                            minHeight: '400px',
                        }}
                    >
                        <Grid container>
                            <Grid item xs={12} sm={6} style={{ padding: 24 }}>
                                <Grid container>
                                    <Grid item xs={12} md={8}>
                                        <h3
                                            style={{
                                                textAlign: 'left',
                                                fontWeight: 600,
                                                color: '#2eafb6',
                                                fontSize: 36,
                                                marginBlockStart: 0,
                                                marginBlockEnd: 0,
                                            }}
                                        >
                                            {this.get('formDownload')}
                                        </h3>
                                        <hr
                                            style={{ border: 'solid 3px #2eafb6', width: 88, margin: '16px 0px' }}
                                            align="left"
                                        />
                                    </Grid>
                                    {this.state.isAdmin ? (
                                        <Grid item xs={12} md={4}>
                                            <Grid container>
                                                <Grid item xs={12}>
                                                    <h5>{this.get('distributorGroupName')}</h5>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <DistrGpSelector
                                                        selectValue={selectedDistrForm}
                                                        onChangeFunc={this.handleSelectFormChange}
                                                        distrGroup={this.props.distr_groups}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    ) : null}

                                    <Grid item sm={12}>
                                        <div style={{ margin: '12px 0px' }}>
                                            <a
                                                href={'/file/config/' + localStorage.getItem('terms_conditions')}
                                                target="_blank"
                                                style={{ textDecoration: 'none', display: 'block' }}
                                            >
                                                <Button variant="outlined">{this.get('consentForm')}</Button>
                                            </a>
                                        </div>
                                        {formToShow.flat()?.map((form) => {
                                            const {
                                                form_description,
                                                form_download_id,
                                                form_file_path,
                                                form_file_name,
                                            } = form;
                                            return (
                                                <div
                                                    style={{ margin: '12px 0px' }}
                                                    key={'form_download_id_' + form_download_id}
                                                    onClick={this.handleClick}
                                                >
                                                    <a
                                                        href={join(
                                                            ApiServerUrl,
                                                            '/file/formOrKnowledge?path=',
                                                            form_file_path,
                                                            '&fileName=',
                                                            form_file_name
                                                        )}
                                                        target="_blank"
                                                        style={{ textDecoration: 'none', display: 'block' }}
                                                    >
                                                        <Button variant="outlined">{form_description}</Button>
                                                    </a>
                                                </div>
                                            );
                                        })}
                                    </Grid>
                                </Grid>

                                {/* <div style={{ margin: "8px 0px" }}>
                  <a href="https://ecom.trioclear.com/Content/Triogram_%20discount_form.pdf" target="_blank" style={{ textDecoration: "none", display: "block" }}>
                    <Button variant="outlined">
                      {this.get('discountForm')}
                    </Button>
                  </a>
                </div> */}
                            </Grid>

                            <Grid item xs={12} sm={6} style={{ display: 'flex' }}>
                                <img
                                    src={getWebAbsPath('/img/support2.png')}
                                    style={{ width: '100%', maxHeight: '400px' }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {Object.keys({ ...this.props.knowledge_base_article, ...this.props.knowledge_base_video }).length ? (
                    <Grid container className={classes.supportContainer}>
                        <Grid
                            item
                            xs={12}
                            style={{
                                boxShadow: '-2px 6px 24px -9px rgba(166,130,166,1)',
                            }}
                        >
                            <Grid container>
                                <Grid item xs={12} style={{ padding: 24 }}>
                                    <Grid container>
                                        <Grid item xs={12} sm={9}>
                                            <h3
                                                style={{
                                                    textAlign: 'left',
                                                    fontWeight: 600,
                                                    color: '#2eafb6',
                                                    fontSize: 36,
                                                    marginBlockStart: 0,
                                                    marginBlockEnd: 0,
                                                }}
                                            >
                                                {this.get('KnowledgeBase.name')}
                                            </h3>
                                            <hr
                                                style={{ border: 'solid 3px #2eafb6', width: 88, margin: '16px 0px' }}
                                                align="left"
                                            />
                                        </Grid>

                                        {this.state.isAdmin ? (
                                            <Grid item xs={12} sm={3}>
                                                <Grid container>
                                                    <Grid item xs={12} sm={12}>
                                                        <h5>{this.get('distributorGroupName')}</h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <DistrGpSelector
                                                            selectValue={selectedDistKnowledge}
                                                            onChangeFunc={this.handleSelectKnowledgeChange}
                                                            distrGroup={this.props.distr_groups}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ) : null}
                                    </Grid>

                                    {knowledgeArticleToShow.flat().length ? (
                                        <KnowledgeForm
                                            title={'Article'}
                                            knowledgeToShow={knowledgeArticleToShow}
                                            rowPerPage={rowPerPageArticle}
                                            firstIndexOfShown={articleShowingFirstIndex}
                                            handleSelectRowPerPageChange={this.handleArticleRowPerPageChange}
                                            handleSetPage={this.handleSetPage}
                                        />
                                    ) : null}

                                    {knowledgeVideoToShow.flat().length ? (
                                        <KnowledgeForm
                                            title={'Video'}
                                            knowledgeToShow={knowledgeVideoToShow}
                                            rowPerPage={rowPerPageVideo}
                                            firstIndexOfShown={videoShowingFirstIndex}
                                            handleSelectRowPerPageChange={this.handleVideoRowPerPageChange}
                                            handleSetPage={this.handleSetPage}
                                        />
                                    ) : null}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ) : null}
            </Animated>
        );
    }
}

const mapStateToProps = (store) => {
    const storeArticle = store.res.knowledge_base_article;
    const storeVideo = store.res.knowledge_base_video;
    const knowledge_base_article = Object.keys(storeArticle).reduce((a, c) => {
        if (!Object.hasOwn(a, storeArticle[c].distr_group_id)) a[storeArticle[c].distr_group_id] = [];
        a[storeArticle[c].distr_group_id].push({
            ...storeArticle[c],
            display_sequence_number: parseInt(storeArticle[c].display_sequence_number),
        });
        return a;
    }, {});
    const knowledge_base_video = Object.keys(storeVideo).reduce((a, c) => {
        if (!Object.hasOwn(a, storeVideo[c].distr_group_id)) a[storeVideo[c].distr_group_id] = [];
        a[storeVideo[c].distr_group_id].push({
            ...storeVideo[c],
            display_sequence_number: parseInt(storeVideo[c].display_sequence_number),
        });
        return a;
    }, {});
    return {
        lang: store.lang,
        config: store.config.config,
        distr_groups: store.res.distr_groups,
        form_download: store.res.form_download,
        knowledge_base_article,
        knowledge_base_video,
    };
};

const sortHelper = (arr) => {
    if (!arr) return [];
    const arrSlice = arr.slice();
    arrSlice.sort((a, b) => a.display_sequence_number - b.display_sequence_number);
    return arrSlice;
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateFrom: () => dispatch(updateRes('form_download')),
        updateKnowledge: () => dispatch(updateRes('knowledge_base')),
        updateDistrGroup: () => dispatch(updateRes('distrgroup')),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withLang(Support, 'Support'))));
